import { usePunditUserContext } from "@circle-react/contexts";

export function useHideEmailsOnMemberProfiles() {
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();
  const isCommunityAdmin = Boolean(currentCommunityMember?.is_admin);
  return Boolean(
    !isCommunityAdmin && currentCommunity?.hide_emails_on_member_profiles,
  );
}
